<template>
  <div>
    <el-dialog
      v-model="isShowDialog"
      width="368px"
      title="验证"
      @close="resetForm('checkUserForm')"
    >
      <el-form
        ref="checkUserForm"
        :model="checkUserForm"
        status-icon
        :rules="rules"
        label-position="left"
      >
        <el-form-item
          label="账号"
          :label-width="formLabelWidth"
          prop="account"
        >
          <el-input
            v-model="checkUserForm.account"
            autocomplete="off"
          />
        </el-form-item>

        <el-form-item
          label="密码"
          :label-width="formLabelWidth"
          prop="password"
        >
          <el-input
            v-model="checkUserForm.password"
            autocomplete="off"
            show-password
          />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button
          class="cancel-button"
          @click="resetForm('checkUserForm')"
        >取消
        </el-button>
        <el-button
          class="confirm-button"
          @click="submitForm('checkUserForm')"
        >确定
        </el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "ConfirmOrder",
  props: {
    changePwd: {
      type: Boolean,
      default: false,
    }
  },
  emits: ["closeChangeForm", "checkOrder"],
  data() {
    const accountValidate = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入账号"));
      } else {
        callback();
      }
    };
    const passwordValidate = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else {
        callback();
      }
    };
    return {
      isShowDialog: false,
      formLabelWidth: "80px",
      checkUserForm: {
        password: "",
        account: "",
        type: "checkPassword"
      },
      rules: {
        account: [{ validator: accountValidate, trigger: "blur" }],
        password: [{ validator: passwordValidate, trigger: "blur" }],
      },

    };
  },
  watch: {
    changePwd: {
      handler(val) {
        this.isShowDialog = val;
      },
      immediate: true
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.$refs["checkUserForm"].resetFields();
    });
  },
  methods: {
    submitForm(formName) {
      this.$emit("checkOrder", this.checkUserForm);
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.$emit("closeChangeForm");
    },

  }
};
</script>

<style scoped lang="scss">
/* 修改密码 */
::v-deep .el-dialog {
  background: #FBFBFB;
  box-shadow: 0 0 6px 0 rgba(69, 69, 69, 0.4);
  border-radius: 10px;
  margin-top: 0 !important;

  .el-dialog__header {
    padding: 0;
    border-bottom: 1px solid #cccccc;
    height: 50px;
    line-height: 50px;
    margin-left: 25px;
  }

  .el-dialog__title {
    font-size: 18px;
    font-weight: bold;
    color: #666666;
    letter-spacing: 4px;
  }

  .el-icon-close:before {
    content: '';
    background: url(../../assets/photos/dialogClose.png) center center no-repeat;
    position: absolute;
    width: 16px;
    height: 16px;
    top: 30%;
    left: 50%;
    transform: translate(-50%, -50%) rotate(180deg);
  }

  .el-dialog__body {
    padding: 0;
    font-size: 14px;
    color: #999999;
    overflow: auto;
    margin-left: 25px;
    margin-right: 25px;
  }

  .el-form {
    margin-top: 20px;
  }

  .el-input__inner {
    background: transparent;
    border: 1px solid #666666;
    border-radius: 8px;
    box-shadow: none;
    height: 30px;
  }

  .el-input__prefix,
  .el-input__suffix {
    color: limegreen;
  }

  .el-button {
    height: 28px;
    margin-left: 25px;
    padding-top: 7px;
  }
}
</style>
